// Unica copia de este texto: la sirven j2l-website (pagina publica y drawers de los footers) y j2l-identity
// (drawer del registro), cada una compilandola contra su propio React y antd.
//
// Al aceptarse en el registro, de este texto se guarda la VERSION, no el contenido: cada alta escribe en
// `UsersConsents` la que `LegalDocuments` (j2l-identity, Jobs2Live.Identity.Domain) declara vigente. Si cambias
// algo de aqui, sube alli `PrivacyPolicyVersion`, o lo que quede guardado dejara de describir lo que el usuario tuvo
// delante. Subirla no le vuelve a pedir el consentimiento a nadie.
//
// Este aviso NO es un control:
//
//   - La constante vive en OTRO repositorio, asi que una PR de aqui no la tiene delante.
//   - El texto va envuelto en `t()`, asi que una edicion puede llegar como cambio de `translations.json` de
//     cualquiera de las dos aplicaciones, donde ningun comentario en un .tsx la ve.

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import { Paragraph, Title, Text, Link } from '../typography';

import styles from './privacy-policy.module.scss';

export interface PrivacyPolicyProps {
  title1FontSize?: number;
  title2FontSize?: number;
  title3FontSize?: number;
  normalTextFontSize?: number;
}

const PrivacyPolicy: FC<PrivacyPolicyProps> = ({ title1FontSize = 30, title2FontSize = 20, normalTextFontSize = 16 }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperContainer}>
        <Typography>
          <Title fontSize={title1FontSize}>{t('Política de privacidad')}</Title>
          <Title level={2} fontSize={title2FontSize}>
            {t('Cláusula. - Protección de datos de firmantes.')}
          </Title>

          <Title level={2} fontSize={title2FontSize}>
            {t('Responsable del tratamiento')}:
          </Title>

          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              {t(
                'El responsable del tratamiento de los datos personales recogidos en este contrato en relación con los representantes legales e interlocutores de las partes (en adelante interesados) y aquellos que se generen como consecuencia de su ejecución es AWESOME COLLABORATIVE MARKET PLACE, S.L. con CIF B44638666 y correo electrónico'
              )}
            </Text>
            &nbsp;
            <Link underline fontSize={normalTextFontSize} color="#1A1C21" href="mailto:privacidad@jobs2live.com">
              privacidad@jobs2live.com
            </Link>
          </Paragraph>

          <Title level={2} fontSize={title2FontSize}>
            {t('Fines del tratamiento')}:
          </Title>

          <Paragraph>
            <Text fontSize={normalTextFontSize}>{t('La finalidad del tratamiento de sus datos es la siguiente')}</Text>:
          </Paragraph>
          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              <ul className={styles.indentedUl}>
                <li>{t('Adherirse a nuestra plataforma y optar a los proyectos que en ella publicitan los clientes finales.')}</li>
                <li>
                  {t(
                    'Llevar a cabo el tratamiento de la información personal de los candidatos con la finalidad de analizar el perfil del candidato para determinar si encaja o no en el puesto vacante.'
                  )}
                </li>
              </ul>
            </Text>
          </Paragraph>

          <Title level={2} fontSize={title2FontSize}>
            {t('Base jurídica del tratamiento')}:
          </Title>

          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              {t(
                'Con carácter general, la legitimación para el tratamiento de los datos de carácter personal se desprende de la propia iniciativa del interesado al cumplimentar sus datos para adherirse a nuestra plataforma y poder formar parte de las personas que optan a puestos de trabajo, por lo que la Compañía dispone del consentimiento inequívoco del mismo para el tratamiento.'
              )}
            </Text>
          </Paragraph>
          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              {t(
                'Igualmente, sus datos serán tratados en el ámbito del interés legítimo del Responsable, por cuanto en necesario para llevar a cabo el proceso de selección a las ofertas que se publiquen en nuestra plataforma y las que Ud. puede optar.'
              )}
            </Text>
          </Paragraph>

          <Title level={2} fontSize={title2FontSize}>
            {t('Fuente de Obtención de los datos')}:
          </Title>

          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              {t(
                'La fuente de obtención es el propio interesado, y, en el caso de que esté disponibles, redes sociales tales como Linkedin o Infojobs.'
              )}
            </Text>
          </Paragraph>

          <Title level={2} fontSize={title2FontSize}>
            {t('Destinatarios de los datos')}:
          </Title>

          <Paragraph>
            <Text fontSize={normalTextFontSize}>{t('Los datos personales serán comunicados a los siguientes terceros:')}</Text>
          </Paragraph>
          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              <ul className={styles.indentedUl}>
                <li>
                  {t(
                    'Clientes finales de los proyectos a los que Ud. muestre su interés en adherirse en nuestra plataforma y para los que opte como candidato.'
                  )}
                </li>
                <li>
                  {t('Jueces y Tribunales, en cumplimiento de requerimientos, obligaciones legales o en el marco de un procedimiento judicial;')}
                </li>
                <li>
                  {t(
                    'y a cualesquiera otros terceros a quienes, en virtud de la normativa vigente aplicable en cada caso, sea necesario llevar a cabo la cesión, tal como órganos de la Administración competentes por motivos de control, registro e inspección.'
                  )}
                </li>
              </ul>
            </Text>
          </Paragraph>

          <Title level={2} fontSize={title2FontSize}>
            {t('Transferencias internacionales')}:
          </Title>

          <Paragraph>
            <Text fontSize={normalTextFontSize}>{t('No existen transferencias internacionales de datos')}</Text>
          </Paragraph>

          <Title level={2} fontSize={title2FontSize}>
            {t('Plazo de conservación de datos')}:
          </Title>

          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              {t(
                'Los datos serán objeto de tratamiento por el periodo que dure el proceso de selección, pudiéndose almacenar su información personal con posterioridad, aunque no haya sido seleccionado, hasta que Ud. revoque su consentimiento, o cierre su cuenta como usuario de la Plataforma.'
              )}
            </Text>
          </Paragraph>

          <Title level={2} fontSize={title2FontSize}>
            {t('Derechos')}:
          </Title>

          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              {t(
                'Las personas interesadas tienen derecho a dirigirse a la dirección que se indica en el apartado Responsable del tratamiento, acompañando en cualquier caso copia del documento que acredite su identidad, para acceder a sus datos personales, así como solicitar la rectificación de los datos inexactos o, en su caso, solicitar su supresión cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos; pudiendo ejercer igualmente su derecho a la portabilidad de sus datos.'
              )}
            </Text>
          </Paragraph>
          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              {t('Los derechos que podrá ejercitar con respecto al tratamiento de sus datos personales son:')}
            </Text>
          </Paragraph>
          <div className={styles.indentedContainer}>
            <Paragraph>
              <Text fontSize={normalTextFontSize}>
                1.&nbsp;
                {t(
                  'Acceso: tendrá Ud. derecho a conocer si estamos tratando sus datos personales, así como los fines de dicho tratamiento, las categorías de datos personales, los destinatarios a los que se comuniquen sus datos, el plazo de conservación de los mismos, así como la información disponible sobre la fuente de obtención de los mismos.'
                )}
              </Text>
            </Paragraph>
            <Paragraph>
              <Text fontSize={normalTextFontSize}>2.&nbsp;{t('Rectificación: de los datos inexactos.')}</Text>
            </Paragraph>
            <Paragraph>
              <Text fontSize={normalTextFontSize}>
                3.&nbsp;
                {t(
                  'Supresión (derecho al olvido): cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.'
                )}
              </Text>
            </Paragraph>
            <Paragraph>
              <Text fontSize={normalTextFontSize}>
                4.&nbsp;
                {t(
                  'Limitación: cuando se impugne la exactitud de los datos, durante el plazo de verificación de los mismos, cuando sean necesarios para el ejercicio o defensa de reclamaciones; o cuando se oponga el interesado a la supresión de los mismos, o al tratamiento de estos, mientras se verifica la existencia de interés legítimo.'
                )}
              </Text>
            </Paragraph>
            <Paragraph>
              <Text fontSize={normalTextFontSize}>
                5.&nbsp;
                {t(
                  'Portabilidad de sus datos: tendrá derecho a recibir sus datos en un formato estructurado, de uso común y lectura mecánica, y a transmitir los mismos a otro responsable.'
                )}
              </Text>
            </Paragraph>
            <Paragraph>
              <Text fontSize={normalTextFontSize}>
                6.&nbsp;
                {t(
                  'Oposición: tendrá derecho a oponerse en cualquier momento, por motivos relacionados con su situación particular, al tratamiento de sus datos con base en un interés público o legítimo del responsable; tras lo que dejarán de tratarse los datos, salvo por motivos legítimos imperiosos, o el ejercicio o la defensa de posibles reclamaciones.'
                )}
              </Text>
            </Paragraph>
            <Paragraph>
              <Text fontSize={normalTextFontSize}>
                7.&nbsp;
                {t(
                  'Decisiones individuales automatizadas: tendrá derecho a no ser objeto de una decisión basada únicamente en el tratamiento automatizado, incluida la elaboración de perfiles, pudiendo solicitar intervención humana en los casos legalmente previstos.'
                )}
              </Text>
            </Paragraph>
          </div>

          <Paragraph>
            <Text fontSize={normalTextFontSize}>
              {t(
                'Finalmente, de acuerdo con los términos establecidos en la legislación vigente, puede Ud. revocar en cualquier momento los consentimientos que nos haya facilitado. Además, si considera que sus datos no han sido tratados conforme a la normativa vigente, puede presentar una denuncia ante la Agencia Española de Protección de Datos, a través de:'
              )}
            </Text>
            &nbsp;
            <Link fontSize={normalTextFontSize} color="#1A1C21" underline href="https://sedeaepd.gob.es/sede-electronica/procedures/claims/info">
              https://sedeaepd.gob.es/sede-electronica/procedures/claims/info
            </Link>
          </Paragraph>
        </Typography>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
